export default [
  {
    name: 'Normas Técnicas',
    path: 'normas-tecnicas',
    component: () => import('@/views/parametrosComCa/normasTecnicas/Index.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'Normas Técnicas' }]
    }
  },
  {
    name: 'Normas Técnicas Adicionar',
    path: 'normas-tecnicas/edit',
    component: () => import('@/views/parametrosComCa/normasTecnicas/Edit.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { name: 'Dados', path: '/dados' },
        { name: 'Normas Técnicas', path: '/parametros-com-ca/normas-tecnicas' },
        { name: 'Adicionar' }
      ]
    }
  },
  {
    name: 'Normas Técnicas Editar',
    path: 'normas-tecnicas/edit/:id',
    component: () => import('@/views/parametrosComCa/normasTecnicas/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      breadcrumb: [
        { name: 'Dados', path: '/dados' },
        { name: 'Normas Técnicas', path: '/parametros-com-ca/normas-tecnicas' },
        { name: 'Editar' }
      ]
    }
  }
];
